const PASSWORD_REGEX = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[^\s]{8,}$/

export function checkPassword(password: string): boolean {
  let valid = !!password && password.length > 0;
  if (valid) {
    valid = PASSWORD_REGEX.test(password);
  }

  return valid;
}
